export let projectionExpressionFiles = [
  'id',
  'estadoFile',
  'estadoItinerario',
  'pendingPreOpIncidents',
  'lastMinute',
  'fileName',
  'fileNumber',
  'dateRange'
];

export let projectionExpressionServicios = [
  'id',
  'cantPersonal',
  'idItinerary',
  'nombreServicio',
  'numReserva',
  'numOS',
  'objProvider.nombre',
  'estadoReserva'
];
